"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Tabs = __importStar(require("@radix-ui/react-tabs"));
var react_1 = require("@stitches/react");
var StyledTabsRoot = (0, react_1.styled)(Tabs.Root, {
    display: "flex",
    flexDirection: "column",
});
var className = "tabs-wrapper";
function TabsWrapper(props) {
    var defaultValue = props.defaultValue, value = props.value, children = props.children, onValueChange = props.onValueChange, otherProps = __rest(props, ["defaultValue", "value", "children", "onValueChange"]);
    return ((0, jsx_runtime_1.jsx)(StyledTabsRoot, __assign({}, otherProps, { defaultValue: defaultValue, onValueChange: onValueChange, value: value, className: "".concat(className, " ").concat(props.className) }, { children: props.children })));
}
exports.TabsWrapper = TabsWrapper;
TabsWrapper.toString = function () { return ".".concat(className); };
//# sourceMappingURL=TabsWrapper.js.map